// @generated by protoc-gen-es v1.10.0
// @generated from file product/v2/product.proto (package product.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, proto3 } from "@bufbuild/protobuf";
import { SubTechnique as SubTechnique$1, Technique as Technique$1 } from "../../common/v1/common_pb.js";

/**
 * ENUMs
 *
 * @generated from enum product.v2.Type
 */
export const Type = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.Type",
  [
    {no: 0, name: "TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TYPE_UPCYCLED", localName: "UPCYCLED"},
    {no: 2, name: "TYPE_SECOND_HAND", localName: "SECOND_HAND"},
    {no: 3, name: "TYPE_VINTAGE", localName: "VINTAGE"},
  ],
);

/**
 * @generated from enum product.v2.Category
 */
export const Category = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.Category",
  [
    {no: 0, name: "CATEGORY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CATEGORY_CLOTHING", localName: "CLOTHING"},
    {no: 2, name: "CATEGORY_ACCESSORIES", localName: "ACCESSORIES"},
    {no: 3, name: "CATEGORY_JEWELRY", localName: "JEWELRY"},
    {no: 4, name: "CATEGORY_REMNANTS", localName: "REMNANTS"},
    {no: 8, name: "CATEGORY_FABRIC", localName: "FABRIC"},
    {no: 5, name: "CATEGORY_NOTIONS", localName: "NOTIONS"},
    {no: 9, name: "CATEGORY_ODDS_AND_ENDS", localName: "ODDS_AND_ENDS"},
    {no: 6, name: "CATEGORY_NOVELTIES", localName: "NOVELTIES"},
    {no: 7, name: "CATEGORY_FOOTWEAR", localName: "FOOTWEAR"},
  ],
);

/**
 * @generated from enum product.v2.SubCategory
 */
export const SubCategory = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.SubCategory",
  [
    {no: 0, name: "SUB_CATEGORY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 5, name: "SUB_CATEGORY_OTHER", localName: "OTHER"},
    {no: 1, name: "SUB_CATEGORY_TOPS", localName: "TOPS"},
    {no: 2, name: "SUB_CATEGORY_BOTTOMS", localName: "BOTTOMS"},
    {no: 3, name: "SUB_CATEGORY_DRESSES", localName: "DRESSES"},
    {no: 4, name: "SUB_CATEGORY_OUTERWEAR", localName: "OUTERWEAR"},
    {no: 6, name: "SUB_CATEGORY_SUITS_AND_BLAZERS", localName: "SUITS_AND_BLAZERS"},
    {no: 8, name: "SUB_CATEGORY_JUMPSUIT", localName: "JUMPSUIT"},
    {no: 9, name: "SUB_CATEGORY_BAGS", localName: "BAGS"},
    {no: 10, name: "SUB_CATEGORY_HATS", localName: "HATS"},
    {no: 11, name: "SUB_CATEGORY_SCARVES", localName: "SCARVES"},
    {no: 12, name: "SUB_CATEGORY_EARRINGS", localName: "EARRINGS"},
    {no: 13, name: "SUB_CATEGORY_NECKLACES", localName: "NECKLACES"},
    {no: 14, name: "SUB_CATEGORY_BRACELETS", localName: "BRACELETS"},
    {no: 15, name: "SUB_CATEGORY_RINGS", localName: "RINGS"},
    {no: 16, name: "SUB_CATEGORY_SNEAKERS", localName: "SNEAKERS"},
    {no: 17, name: "SUB_CATEGORY_SANDALS", localName: "SANDALS"},
    {no: 18, name: "SUB_CATEGORY_BOOTS", localName: "BOOTS"},
    {no: 19, name: "SUB_CATEGORY_HEELS", localName: "HEELS"},
    {no: 20, name: "SUB_CATEGORY_FLATS", localName: "FLATS"},
    {no: 21, name: "SUB_CATEGORY_REMNANTS", localName: "REMNANTS"},
    {no: 22, name: "SUB_CATEGORY_SCRAPS", localName: "SCRAPS"},
    {no: 23, name: "SUB_CATEGORY_BOLTS_AND_ROLLS", localName: "BOLTS_AND_ROLLS"},
    {no: 24, name: "SUB_CATEGORY_BEDDING", localName: "BEDDING"},
    {no: 25, name: "SUB_CATEGORY_CURTAINS", localName: "CURTAINS"},
    {no: 26, name: "SUB_CATEGORY_PLUSH", localName: "PLUSH"},
    {no: 27, name: "SUB_CATEGORY_TRINKETS", localName: "TRINKETS"},
    {no: 28, name: "SUB_CATEGORY_NOVELTIES", localName: "NOVELTIES"},
    {no: 7, name: "SUB_CATEGORY_JUMPSUIT_AND_ROMPERS", localName: "JUMPSUIT_AND_ROMPERS"},
  ],
);

/**
 * @generated from enum product.v2.Identifier
 */
export const Identifier = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.Identifier",
  [
    {no: 0, name: "IDENTIFIER_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "IDENTIFIER_OTHER", localName: "OTHER"},
    {no: 2, name: "IDENTIFIER_BUTTON_UP", localName: "BUTTON_UP"},
    {no: 3, name: "IDENTIFIER_T_SHIRT", localName: "T_SHIRT"},
    {no: 4, name: "IDENTIFIER_SWEATER", localName: "SWEATER"},
    {no: 5, name: "IDENTIFIER_SWEATSHIRT", localName: "SWEATSHIRT"},
    {no: 6, name: "IDENTIFIER_HOODIE", localName: "HOODIE"},
    {no: 7, name: "IDENTIFIER_TUNIC", localName: "TUNIC"},
    {no: 8, name: "IDENTIFIER_TANK_TOP", localName: "TANK_TOP"},
    {no: 9, name: "IDENTIFIER_BUSTIER", localName: "BUSTIER"},
    {no: 10, name: "IDENTIFIER_SKIRT", localName: "SKIRT"},
    {no: 11, name: "IDENTIFIER_PANTS", localName: "PANTS"},
    {no: 12, name: "IDENTIFIER_JEANS", localName: "JEANS"},
    {no: 13, name: "IDENTIFIER_SHORTS", localName: "SHORTS"},
    {no: 14, name: "IDENTIFIER_MINI", localName: "MINI"},
    {no: 15, name: "IDENTIFIER_MIDI", localName: "MIDI"},
    {no: 16, name: "IDENTIFIER_MAXI", localName: "MAXI"},
    {no: 17, name: "IDENTIFIER_COAT", localName: "COAT"},
    {no: 18, name: "IDENTIFIER_JACKET", localName: "JACKET"},
    {no: 19, name: "IDENTIFIER_VEST", localName: "VEST"},
    {no: 20, name: "IDENTIFIER_SUIT", localName: "SUIT"},
    {no: 21, name: "IDENTIFIER_BLAZER", localName: "BLAZER"},
    {no: 22, name: "IDENTIFIER_JUMPSUIT", localName: "JUMPSUIT"},
    {no: 23, name: "IDENTIFIER_ROMPER", localName: "ROMPER"},
    {no: 53, name: "IDENTIFIER_PANT_SUITS", localName: "PANT_SUITS"},
    {no: 54, name: "IDENTIFIER_SKIRT_SUITS", localName: "SKIRT_SUITS"},
    {no: 55, name: "IDENTIFIER_BLAZERS", localName: "BLAZERS"},
    {no: 24, name: "IDENTIFIER_BAG", localName: "BAG"},
    {no: 25, name: "IDENTIFIER_SHOE", localName: "SHOE"},
    {no: 26, name: "IDENTIFIER_HAT", localName: "HAT"},
    {no: 27, name: "IDENTIFIER_SCARF", localName: "SCARF"},
    {no: 28, name: "IDENTIFIER_EARRING", localName: "EARRING"},
    {no: 29, name: "IDENTIFIER_NECKLACE", localName: "NECKLACE"},
    {no: 30, name: "IDENTIFIER_BRACELET", localName: "BRACELET"},
    {no: 31, name: "IDENTIFIER_RING", localName: "RING"},
    {no: 43, name: "IDENTIFIER_TRIM", localName: "TRIM"},
    {no: 44, name: "IDENTIFIER_APPLIQUE", localName: "APPLIQUE"},
    {no: 45, name: "IDENTIFIER_BUTTONS", localName: "BUTTONS"},
    {no: 46, name: "IDENTIFIER_THREAD", localName: "THREAD"},
    {no: 47, name: "IDENTIFIER_YARN", localName: "YARN"},
    {no: 48, name: "IDENTIFIER_JEWELERY_COMPONENT", localName: "JEWELERY_COMPONENT"},
    {no: 49, name: "IDENTIFIER_TRINKET", localName: "TRINKET"},
    {no: 50, name: "IDENTIFIER_PLUSH", localName: "PLUSH"},
    {no: 51, name: "IDENTIFIER_PATCH", localName: "PATCH"},
    {no: 52, name: "IDENTIFIER_QUILT", localName: "QUILT"},
  ],
);

/**
 * @generated from enum product.v2.Color
 */
export const Color = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.Color",
  [
    {no: 0, name: "COLOR_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "COLOR_MULTI", localName: "MULTI"},
    {no: 2, name: "COLOR_OTHER", localName: "OTHER"},
    {no: 3, name: "COLOR_RED", localName: "RED"},
    {no: 4, name: "COLOR_ORANGE", localName: "ORANGE"},
    {no: 5, name: "COLOR_YELLOW", localName: "YELLOW"},
    {no: 6, name: "COLOR_GREEN", localName: "GREEN"},
    {no: 7, name: "COLOR_BLUE", localName: "BLUE"},
    {no: 8, name: "COLOR_WHITE", localName: "WHITE"},
    {no: 9, name: "COLOR_BLACK", localName: "BLACK"},
    {no: 10, name: "COLOR_PURPLE", localName: "PURPLE"},
    {no: 11, name: "COLOR_PINK", localName: "PINK"},
    {no: 12, name: "COLOR_BROWN", localName: "BROWN"},
    {no: 13, name: "COLOR_TAN", localName: "TAN"},
    {no: 14, name: "COLOR_CREAM", localName: "CREAM"},
    {no: 15, name: "COLOR_SILVER", localName: "SILVER"},
    {no: 16, name: "COLOR_GOLD", localName: "GOLD"},
    {no: 17, name: "COLOR_GRAY", localName: "GRAY"},
  ],
);

/**
 * @generated from enum product.v2.Pattern
 */
export const Pattern = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.Pattern",
  [
    {no: 0, name: "PATTERN_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PATTERN_STRIPES", localName: "STRIPES"},
    {no: 2, name: "PATTERN_POLKA_DOTS", localName: "POLKA_DOTS"},
    {no: 3, name: "PATTERN_PLAID", localName: "PLAID"},
    {no: 4, name: "PATTERN_FLORAL", localName: "FLORAL"},
    {no: 5, name: "PATTERN_ANIMAL_PRINT", localName: "ANIMAL_PRINT"},
  ],
);

/**
 * @generated from enum product.v2.Material
 */
export const Material = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.Material",
  [
    {no: 0, name: "MATERIAL_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "MATERIAL_OTHER", localName: "OTHER"},
    {no: 2, name: "MATERIAL_COTTON", localName: "COTTON"},
    {no: 3, name: "MATERIAL_WOOL", localName: "WOOL"},
    {no: 4, name: "MATERIAL_SILK", localName: "SILK"},
    {no: 5, name: "MATERIAL_LINEN", localName: "LINEN"},
    {no: 6, name: "MATERIAL_DENIM", localName: "DENIM"},
    {no: 7, name: "MATERIAL_POLYESTER", localName: "POLYESTER"},
    {no: 8, name: "MATERIAL_NYLON", localName: "NYLON"},
    {no: 9, name: "MATERIAL_RAYON", localName: "RAYON"},
    {no: 10, name: "MATERIAL_FUR", localName: "FUR"},
    {no: 11, name: "MATERIAL_LEATHER", localName: "LEATHER"},
    {no: 12, name: "MATERIAL_METAL", localName: "METAL"},
    {no: 13, name: "MATERIAL_GEMS", localName: "GEMS"},
    {no: 14, name: "MATERIAL_STONES", localName: "STONES"},
    {no: 15, name: "MATERIAL_PLASTIC", localName: "PLASTIC"},
    {no: 16, name: "MATERIAL_CERAMIC", localName: "CERAMIC"},
    {no: 17, name: "MATERIAL_GLASS", localName: "GLASS"},
  ],
);

/**
 * @generated from enum product.v2.Decade
 */
export const Decade = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.Decade",
  [
    {no: 0, name: "DECADE_UNSPECIFIED"},
    {no: 1, name: "DECADE_ANTIQUE"},
    {no: 2, name: "DECADE_Y2K"},
    {no: 3, name: "DECADE_90S"},
    {no: 4, name: "DECADE_80S"},
    {no: 5, name: "DECADE_70S"},
    {no: 6, name: "DECADE_60S"},
    {no: 7, name: "DECADE_50S"},
    {no: 8, name: "DECADE_40S"},
    {no: 9, name: "DECADE_30S"},
    {no: 10, name: "DECADE_20S"},
  ],
);

/**
 * @generated from enum product.v2.Condition
 */
export const Condition = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.Condition",
  [
    {no: 0, name: "CONDITION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CONDITION_PRISTINE", localName: "PRISTINE"},
    {no: 2, name: "CONDITION_GOOD", localName: "GOOD"},
    {no: 3, name: "CONDITION_DEFECTIVE", localName: "DEFECTIVE"},
  ],
);

/**
 * @generated from enum product.v2.UnitOfMeasurement
 */
export const UnitOfMeasurement = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.UnitOfMeasurement",
  [
    {no: 0, name: "UNIT_OF_MEASUREMENT_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "UNIT_OF_MEASUREMENT_INCHES", localName: "INCHES"},
  ],
);

/**
 * @generated from enum product.v2.SizeType
 */
export const SizeType = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.SizeType",
  [
    {no: 0, name: "SIZE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SIZE_TYPE_WOMEN", localName: "WOMEN"},
    {no: 2, name: "SIZE_TYPE_MEN", localName: "MEN"},
  ],
);

/**
 * @generated from enum product.v2.SizeCategory
 */
export const SizeCategory = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.SizeCategory",
  [
    {no: 0, name: "SIZE_CATEGORY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SIZE_CATEGORY_CLOTHING", localName: "CLOTHING"},
    {no: 2, name: "SIZE_CATEGORY_SHOE", localName: "SHOE"},
    {no: 3, name: "SIZE_CATEGORY_ACCESSORY", localName: "ACCESSORY"},
  ],
);

/**
 * @generated from enum product.v2.SizeSubCategory
 */
export const SizeSubCategory = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.SizeSubCategory",
  [
    {no: 0, name: "SIZE_SUB_CATEGORY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SIZE_SUB_CATEGORY_GENERAL", localName: "GENERAL"},
  ],
);

/**
 * @generated from enum product.v2.SizeRegion
 */
export const SizeRegion = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.SizeRegion",
  [
    {no: 0, name: "SIZE_REGION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SIZE_REGION_US", localName: "US"},
  ],
);

/**
 * @generated from enum product.v2.AlphaSize
 */
export const AlphaSize = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.AlphaSize",
  [
    {no: 0, name: "ALPHA_SIZE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ALPHA_SIZE_XXXS", localName: "XXXS"},
    {no: 2, name: "ALPHA_SIZE_XXS", localName: "XXS"},
    {no: 3, name: "ALPHA_SIZE_XS", localName: "XS"},
    {no: 4, name: "ALPHA_SIZE_S", localName: "S"},
    {no: 5, name: "ALPHA_SIZE_M", localName: "M"},
    {no: 6, name: "ALPHA_SIZE_L", localName: "L"},
    {no: 7, name: "ALPHA_SIZE_XL", localName: "XL"},
    {no: 8, name: "ALPHA_SIZE_XXL", localName: "XXL"},
    {no: 9, name: "ALPHA_SIZE_XXXL", localName: "XXXL"},
  ],
);

/**
 * @generated from enum product.v2.ShoeWidth
 */
export const ShoeWidth = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.ShoeWidth",
  [
    {no: 0, name: "SHOE_WIDTH_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SHOE_WIDTH_NARROW", localName: "NARROW"},
    {no: 2, name: "SHOE_WIDTH_MEDIUM", localName: "MEDIUM"},
    {no: 3, name: "SHOE_WIDTH_WIDE", localName: "WIDE"},
    {no: 4, name: "SHOE_WIDTH_XWIDE", localName: "XWIDE"},
  ],
);

/**
 * @generated from enum product.v2.SortBy
 */
export const SortBy = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.SortBy",
  [
    {no: 0, name: "SORT_BY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SORT_BY_PRICE", localName: "PRICE"},
    {no: 2, name: "SORT_BY_CREATED_AT", localName: "CREATED_AT"},
    {no: 3, name: "SORT_BY_IS_SOLD", localName: "IS_SOLD"},
  ],
);

/**
 * Deprecated: Use common Technique and SubTechnique instead.
 *
 * @generated from enum product.v2.Technique
 */
export const Technique = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.Technique",
  [
    {no: 0, name: "TECHNIQUE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TECHNIQUE_REWORK", localName: "REWORK"},
    {no: 2, name: "TECHNIQUE_STITCH", localName: "STITCH"},
    {no: 3, name: "TECHNIQUE_PATCHWORK", localName: "PATCHWORK"},
    {no: 4, name: "TECHNIQUE_EMBELLISH", localName: "EMBELLISH"},
    {no: 5, name: "TECHNIQUE_DISTRESS", localName: "DISTRESS"},
    {no: 6, name: "TECHNIQUE_WEAVE_OR_KNOT", localName: "WEAVE_OR_KNOT"},
    {no: 7, name: "TECHNIQUE_PAINT", localName: "PAINT"},
    {no: 8, name: "TECHNIQUE_PRINT", localName: "PRINT"},
    {no: 9, name: "TECHNIQUE_DYE", localName: "DYE"},
  ],
);

/**
 * @generated from enum product.v2.SubTechnique
 */
export const SubTechnique = /*@__PURE__*/ proto3.makeEnum(
  "product.v2.SubTechnique",
  [
    {no: 0, name: "SUB_TECHNIQUE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SUB_TECHNIQUE_DECONSTRUCTION", localName: "DECONSTRUCTION"},
    {no: 2, name: "SUB_TECHNIQUE_RECONSTRUCTION", localName: "RECONSTRUCTION"},
    {no: 3, name: "SUB_TECHNIQUE_REPURPOSE", localName: "REPURPOSE"},
    {no: 4, name: "SUB_TECHNIQUE_EMBROIDERY", localName: "EMBROIDERY"},
    {no: 5, name: "SUB_TECHNIQUE_SHASHIKO", localName: "SHASHIKO"},
    {no: 6, name: "SUB_TECHNIQUE_BORO", localName: "BORO"},
    {no: 7, name: "SUB_TECHNIQUE_PIECEING", localName: "PIECEING"},
    {no: 8, name: "SUB_TECHNIQUE_QUILT", localName: "QUILT"},
    {no: 9, name: "SUB_TECHNIQUE_APPLIQUE", localName: "APPLIQUE"},
    {no: 10, name: "SUB_TECHNIQUE_BEADS", localName: "BEADS"},
    {no: 11, name: "SUB_TECHNIQUE_PATCHES", localName: "PATCHES"},
    {no: 12, name: "SUB_TECHNIQUE_SEQUINS", localName: "SEQUINS"},
    {no: 13, name: "SUB_TECHNIQUE_JEWELS", localName: "JEWELS"},
    {no: 14, name: "SUB_TECHNIQUE_TRIM", localName: "TRIM"},
    {no: 15, name: "SUB_TECHNIQUE_CUTTING", localName: "CUTTING"},
    {no: 16, name: "SUB_TECHNIQUE_FRAYING", localName: "FRAYING"},
    {no: 17, name: "SUB_TECHNIQUE_SANDING", localName: "SANDING"},
    {no: 18, name: "SUB_TECHNIQUE_WIRE_BRUSH", localName: "WIRE_BRUSH"},
    {no: 19, name: "SUB_TECHNIQUE_CROCHET", localName: "CROCHET"},
    {no: 20, name: "SUB_TECHNIQUE_KNIT", localName: "KNIT"},
    {no: 21, name: "SUB_TECHNIQUE_MACRAME", localName: "MACRAME"},
    {no: 22, name: "SUB_TECHNIQUE_BRUSH", localName: "BRUSH"},
    {no: 23, name: "SUB_TECHNIQUE_PENS", localName: "PENS"},
    {no: 24, name: "SUB_TECHNIQUE_SPONGE", localName: "SPONGE"},
    {no: 25, name: "SUB_TECHNIQUE_SPLATTER", localName: "SPLATTER"},
    {no: 26, name: "SUB_TECHNIQUE_AIR_BRUSH", localName: "AIR_BRUSH"},
    {no: 27, name: "SUB_TECHNIQUE_SILK_SCREEN", localName: "SILK_SCREEN"},
    {no: 28, name: "SUB_TECHNIQUE_TRANSFER", localName: "TRANSFER"},
    {no: 29, name: "SUB_TECHNIQUE_BLOCK_PRINT", localName: "BLOCK_PRINT"},
    {no: 30, name: "SUB_TECHNIQUE_TIE_DYE", localName: "TIE_DYE"},
    {no: 31, name: "SUB_TECHNIQUE_BLEACH", localName: "BLEACH"},
    {no: 32, name: "SUB_TECHNIQUE_SHIBORI", localName: "SHIBORI"},
    {no: 33, name: "SUB_TECHNIQUE_BATIK", localName: "BATIK"},
    {no: 34, name: "SUB_TECHNIQUE_CYANOTYPE", localName: "CYANOTYPE"},
  ],
);

/**
 * @generated from message product.v2.CreateProductRequest
 */
export const CreateProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.CreateProductRequest",
  () => [
    { no: 1, name: "product", kind: "message", T: Product },
  ],
);

/**
 * @generated from message product.v2.CreateProductResponse
 */
export const CreateProductResponse = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.CreateProductResponse",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message product.v2.GetProductRequest
 */
export const GetProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.GetProductRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message product.v2.GetProductResponse
 */
export const GetProductResponse = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.GetProductResponse",
  () => [
    { no: 1, name: "product", kind: "message", T: Product },
  ],
);

/**
 * @generated from message product.v2.UpdateProductRequest
 */
export const UpdateProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.UpdateProductRequest",
  () => [
    { no: 1, name: "product", kind: "message", T: Product },
  ],
);

/**
 * @generated from message product.v2.UpdateProductResponse
 */
export const UpdateProductResponse = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.UpdateProductResponse",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message product.v2.DeleteProductRequest
 */
export const DeleteProductRequest = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.DeleteProductRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "purge", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message product.v2.DeleteProductResponse
 */
export const DeleteProductResponse = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.DeleteProductResponse",
  [],
);

/**
 * @generated from message product.v2.ListProductsRequest
 */
export const ListProductsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.ListProductsRequest",
  () => [
    { no: 1, name: "filter", kind: "message", T: ProductFilter },
  ],
);

/**
 * @generated from message product.v2.ListProductsResponse
 */
export const ListProductsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.ListProductsResponse",
  () => [
    { no: 1, name: "products", kind: "message", T: Product, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message product.v2.Product
 */
export const Product = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.Product",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(Type) },
    { no: 3, name: "category", kind: "enum", T: proto3.getEnumType(Category) },
    { no: 4, name: "sub_category", kind: "enum", T: proto3.getEnumType(SubCategory) },
    { no: 5, name: "identifier", kind: "enum", T: proto3.getEnumType(Identifier) },
    { no: 6, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "is_deleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "seller_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "name_lower", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "description_lower", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 15, name: "quantity", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 16, name: "descriptors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "descriptors_lower", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 18, name: "images", kind: "message", T: Image, repeated: true },
    { no: 19, name: "videos", kind: "message", T: Video, repeated: true },
    { no: 20, name: "primary_color", kind: "enum", T: proto3.getEnumType(Color) },
    { no: 21, name: "secondary_colors", kind: "enum", T: proto3.getEnumType(Color), repeated: true },
    { no: 22, name: "patterns", kind: "enum", T: proto3.getEnumType(Pattern), repeated: true },
    { no: 23, name: "weight_pounds", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 24, name: "weight_ounces", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 25, name: "materials", kind: "enum", T: proto3.getEnumType(Material), repeated: true },
    { no: 26, name: "vintage", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 27, name: "decade", kind: "enum", T: proto3.getEnumType(Decade) },
    { no: 28, name: "condition", kind: "enum", T: proto3.getEnumType(Condition) },
    { no: 29, name: "unit_of_measurement", kind: "enum", T: proto3.getEnumType(UnitOfMeasurement) },
    { no: 30, name: "chest", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 31, name: "length", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 32, name: "sleeve", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 33, name: "waist", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 34, name: "rise", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 35, name: "inseam", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 36, name: "shoulders", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 37, name: "width", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 38, name: "depth", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 39, name: "shoulder_drop", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 40, name: "heel_height", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 41, name: "diameter", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 42, name: "height", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 43, name: "ring_size", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 44, name: "size_type", kind: "enum", T: proto3.getEnumType(SizeType) },
    { no: 45, name: "size_category", kind: "enum", T: proto3.getEnumType(SizeCategory) },
    { no: 46, name: "size_sub_category", kind: "enum", T: proto3.getEnumType(SizeSubCategory) },
    { no: 47, name: "size_region", kind: "enum", T: proto3.getEnumType(SizeRegion) },
    { no: 48, name: "alpha_size", kind: "enum", T: proto3.getEnumType(AlphaSize) },
    { no: 49, name: "numeric_size", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 50, name: "shoe_width", kind: "enum", T: proto3.getEnumType(ShoeWidth) },
    { no: 51, name: "shipping_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 52, name: "marketplace_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 53, name: "is_sold", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 54, name: "total_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 55, name: "platform_height", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 56, name: "techniques", kind: "enum", T: proto3.getEnumType(Technique), repeated: true },
    { no: 57, name: "sub_techniques", kind: "enum", T: proto3.getEnumType(SubTechnique), repeated: true },
    { no: 58, name: "new_techniques", kind: "enum", T: proto3.getEnumType(Technique$1), repeated: true },
    { no: 59, name: "new_sub_techniques", kind: "enum", T: proto3.getEnumType(SubTechnique$1), repeated: true },
  ],
);

/**
 * @generated from message product.v2.ProductFilter
 */
export const ProductFilter = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.ProductFilter",
  () => [
    { no: 1, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "sort_by", kind: "enum", T: proto3.getEnumType(SortBy) },
    { no: 4, name: "sort_ascending", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "created_after", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_before", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "updated_after", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated_before", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_deleted", kind: "message", T: BoolValue },
    { no: 10, name: "global_filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "seller_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "min_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "max_price", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 14, name: "types", kind: "enum", T: proto3.getEnumType(Type), repeated: true },
    { no: 15, name: "category", kind: "enum", T: proto3.getEnumType(Category), repeated: true },
    { no: 16, name: "sub_category", kind: "enum", T: proto3.getEnumType(SubCategory), repeated: true },
    { no: 17, name: "identifiers", kind: "enum", T: proto3.getEnumType(Identifier), repeated: true },
    { no: 18, name: "is_vintage", kind: "message", T: BoolValue },
    { no: 19, name: "primary_colors", kind: "enum", T: proto3.getEnumType(Color), repeated: true },
    { no: 20, name: "secondary_colors", kind: "enum", T: proto3.getEnumType(Color), repeated: true },
    { no: 21, name: "patterns", kind: "enum", T: proto3.getEnumType(Pattern), repeated: true },
    { no: 22, name: "materials", kind: "enum", T: proto3.getEnumType(Material), repeated: true },
    { no: 23, name: "decades", kind: "enum", T: proto3.getEnumType(Decade), repeated: true },
    { no: 24, name: "conditions", kind: "enum", T: proto3.getEnumType(Condition), repeated: true },
    { no: 25, name: "size_types", kind: "enum", T: proto3.getEnumType(SizeType), repeated: true },
    { no: 26, name: "alpha_sizes", kind: "enum", T: proto3.getEnumType(AlphaSize), repeated: true },
    { no: 27, name: "total_results_cap", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 28, name: "is_sold", kind: "message", T: BoolValue },
    { no: 29, name: "has_video", kind: "message", T: BoolValue },
    { no: 30, name: "techniques", kind: "enum", T: proto3.getEnumType(Technique), repeated: true },
    { no: 31, name: "sub_techniques", kind: "enum", T: proto3.getEnumType(SubTechnique), repeated: true },
    { no: 32, name: "new_techniques", kind: "enum", T: proto3.getEnumType(Technique$1), repeated: true },
    { no: 33, name: "new_sub_techniques", kind: "enum", T: proto3.getEnumType(SubTechnique$1), repeated: true },
  ],
);

/**
 * @generated from message product.v2.Image
 */
export const Image = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.Image",
  () => [
    { no: 1, name: "image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "image_alt_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message product.v2.Video
 */
export const Video = /*@__PURE__*/ proto3.makeMessageType(
  "product.v2.Video",
  () => [
    { no: 1, name: "video_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "video_alt_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

